import * as React from 'react';
import { DialogContent, DialogTitle, Divider, Drawer, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function AlertDrawer ({ drawerAlert = null, closeDrawer, title }) {
    return (
        <Drawer
          open={!!drawerAlert}
          anchor='bottom'
          onClose={closeDrawer}>
            <DialogTitle variant='drawer-dialog-title'>
                <CloseIcon onClick={closeDrawer} />
                <Typography>{title}</Typography>
            </DialogTitle>
            <Divider />
            <DialogContent variant='drawer-dialog-content'>
                {drawerAlert}
            </DialogContent>
        </Drawer>
    );
}
